// FILE: src/components/MapView.js
// Updated to use the react-leaflet library for better integration with React.

import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// The CSS import has been moved to src/index.js
import L from 'leaflet';

// Fix for default icon issue with Webpack
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;


export default function MapView({ restaurants, onRestaurantClick }) {
    // Default center for the map, e.g., St Helens
    const mapCenter = [53.454, -2.733];

    return (
        <MapContainer center={mapCenter} zoom={12} style={{ height: '600px', width: '100%' }} className="rounded-lg shadow-md">
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            {restaurants.map(restaurant => (
                (restaurant.latitude && restaurant.longitude) && (
                    <Marker 
                        key={restaurant.id} 
                        position={[restaurant.latitude, restaurant.longitude]}
                        eventHandlers={{
                            click: () => {
                                onRestaurantClick(restaurant);
                            },
                        }}
                    >
                        <Popup>
                            <b>{restaurant.name}</b><br />{restaurant.cuisine}
                        </Popup>
                    </Marker>
                )
            ))}
        </MapContainer>
    );
}
